import axios from "axios";

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || "http://localhost:5001/api",
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fogra_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("fogra_token");
      localStorage.removeItem("fogra_user");
    }
    return Promise.reject(err);
  }
);

export const authAPI = {
  register: (data) => api.post("/auth/register", data),
  login:    (data) => api.post("/auth/login", data),
  me:       ()     => api.get("/auth/me"),
  updateProfile: (data) => api.put("/auth/profile", data),
};

export const questionsAPI = {
  list:     (params) => api.get("/questions", { params }),
  get:      (slug)   => api.get(`/questions/${slug}`),
  create:   (data)   => api.post("/questions", data),
  update:   (id, data) => api.put(`/questions/${id}`, data),
  delete:   (id)     => api.delete(`/questions/${id}`),
  feed:     (params) => api.get("/questions/feed", { params }),
  search:   (params) => api.get("/questions/search", { params }),
  vote:     (id, value) => api.post(`/questions/${id}/vote`, { value }),
  bookmark: (id)     => api.post(`/questions/${id}/bookmark`),
};

export const answersAPI = {
  create: (data)    => api.post("/answers", data),
  update: (id, data) => api.put(`/answers/${id}`, data),
  delete: (id)      => api.delete(`/answers/${id}`),
  vote:   (id, value) => api.post(`/answers/${id}/vote`, { value }),
  accept: (id)      => api.post(`/answers/${id}/accept`),
};

export const topicsAPI = {
  list:   ()     => api.get("/topics"),
  get:    (slug) => api.get(`/topics/${slug}`),
  follow: (id)   => api.post(`/topics/${id}/follow`),
};

export const commentsAPI = {
  list:   (answerId) => api.get(`/comments/${answerId}`),
  create: (data)     => api.post("/comments", data),
  delete: (id)       => api.delete(`/comments/${id}`),
};

export const notificationsAPI = {
  list:    () => api.get("/notifications"),
  readAll: () => api.put("/notifications/read"),
  readOne: (id) => api.put(`/notifications/${id}/read`),
};

export const usersAPI = {
  get:       (username) => api.get(`/users/${username}`),
  follow:    (id)       => api.post(`/users/${id}/follow`),
  bookmarks: (username) => api.get(`/users/${username}/bookmarks`),
};

export default api;

export const listingsAPI = {
  list:       (params) => api.get("/listings", { params }),
  get:        (slug)   => api.get(`/listings/${slug}`),
  create:     (data)   => api.post("/listings", data),
  review:     (id, data) => api.post(`/listings/${id}/reviews`, data),
  complaint:  (id, data) => api.post(`/listings/${id}/complaints`, data),
  verify:     (id)     => api.put(`/listings/${id}/verify`),
  flag:       (id)     => api.put(`/listings/${id}/flag`),
  questions:  (id)     => api.get(`/listings/${id}/questions`),
};
